import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 03720A4C-EA6B-4D58-B7D8-5A8DA745B125
 * name microsoft-xbox-controller-menu
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-xbox-controller-menu.svg
 * tags
 * - Gaming / RPG 
 */
export const MicrosoftXboxControllerMenuIcon = createSvgIcon(<><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M6,7H18V9H6V7M6,11H18V13H6V11M6,15H18V17H6V15Z" /></>, 'MicrosoftXboxControllerMenuIcon');
export default MicrosoftXboxControllerMenuIcon